module.exports = __webpack_public_path__ + "static/media/path0202.9e81793f.jpg";